/**
 * render recapcha
 */
const RECAPTCHA_SITE_KEY = document.querySelector('meta[name="sumo:recaptcha_site_key"]').content || '';

export const renderRecaptcha = () => {
	if (window.grecaptcha) {
		window.grecaptcha.render('slf-recaptcha', {
			sitekey: RECAPTCHA_SITE_KEY,
			theme: 'light',
			size: 'invisible',
			callback: function (token) {
				window.sessionStorage.setItem('slf_rr', true);
			},
		});
	}
};

export const getRecaptcha = async () => {
	await window.grecaptcha.reset();
	await window.grecaptcha.execute();
	return window.grecaptcha.getResponse();
};
